import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Chip, CircularProgress, Paper, Divider, Stack } from '@mui/material';
import chatApi from '../../chat/api/chatApi';
import { useQuery } from 'react-query';
import { format } from 'date-fns';
import { fi } from 'date-fns/locale';

const formatDate = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  return format(d, 'dd.MM.yyyy HH:mm', { locale: fi });
};

const ConversationDetailPage = () => {
  const { id } = useParams();
  const { data: conversation, isLoading, error } = useQuery(
    ['conversation', id],
    () => chatApi.getConversation(id),
    { enabled: !!id }
  );

  if (isLoading) {
    return <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px"><CircularProgress /></Box>;
  }
  if (error) {
    return <Typography color="error">Virhe ladattaessa keskustelua: {error.message || 'Tuntematon virhe'}</Typography>;
  }
  if (!conversation) {
    return <Typography>Ei keskustelun tietoja.</Typography>;
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>Keskustelu {conversation._id?.slice(-6) || conversation.id?.slice(-6) || ''}</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={2}>
        <Chip label={conversation.status === 'active' ? 'Aktiivinen' : 'Valmis'} color={conversation.status === 'active' ? 'warning' : 'success'} />
        <Chip label={`Viestit: ${conversation.messages?.length || 0}`} color="primary" />
        <Chip label={`Käyttäjä: ${conversation.userId?.name || conversation.userId?.email || conversation.userId || 'Tuntematon'}`} />
      </Stack>
      <Typography variant="body2" color="text.secondary" mb={1}>Luotu: {formatDate(conversation.createdAt)}</Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>Päivitetty: {formatDate(conversation.updatedAt)}</Typography>
      {conversation.agentState && (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle2">Agentin tila:</Typography>
          <pre style={{ margin: 0, fontSize: 14 }}>{JSON.stringify(conversation.agentState, null, 2)}</pre>
        </Paper>
      )}
      <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Viestit</Typography>
      <Divider sx={{ mb: 2 }} />
      <Stack spacing={2}>
        {conversation.messages?.map((msg, idx) => (
          <Paper key={idx} variant="outlined" sx={{ p: 2 }}>
            <Stack direction="row" spacing={2} alignItems="center" mb={1}>
              <Chip label={msg.role} size="small" />
              <Chip label={msg.type} size="small" variant="outlined" />
              <Typography variant="caption" color="text.secondary">{formatDate(msg.timestamp)}</Typography>
            </Stack>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {typeof msg.content === 'string' ? msg.content : JSON.stringify(msg.content, null, 2)}
            </Typography>
          </Paper>
        ))}
        {(!conversation.messages || conversation.messages.length === 0) && (
          <Typography variant="body2" color="text.secondary">Ei viestejä.</Typography>
        )}
      </Stack>
    </Box>
  );
};

export default ConversationDetailPage; 